import axios from 'axios';
import authHeader from '@/services/auth-header';

class DocuSignService {
  // patchOne(fileDataId, docPackageId) {
  //   return axios.patch(`${process.env.VUE_APP_API_BASE_URL}/api/feature/docuSign/${fileDataId}/${docPackageId}`,
  //   null,
  //   {
  //     headers: authHeader() 
  //   })
  //   .then(response => {
  //     return response;
  //   });
  // }

  patch(fileDataId) {
    return axios.patch(`${process.env.VUE_APP_API_BASE_URL}/api/feature/docuSign/${fileDataId}`,
    null,
    {
      headers: authHeader() 
    })
    .then(response => {
      return response;
    });
  }

  cancel(docusignEnvelopeId) {
    return axios.delete(`${process.env.VUE_APP_API_BASE_URL}/api/feature/docuSign/Cancel/${docusignEnvelopeId}`,
    {
      headers: authHeader() 
    })
    .then(response => {
      return response;
    });
  }

  getDocuSignApiSettings() {
    return axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/feature/docuSign/DocuSignApiSettings`,
    {
      headers: authHeader() 
    })
    .then(response => {
      return response;
    });
  }
  
  resend(fileDataId, docPackageId){
    return axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/feature/docuSign/resend/${fileDataId}/${docPackageId}`,
    null,
    {
      headers: authHeader() 
    })
    .then(response => {
      return response;
    });
  }
  
  getSignedDocuments(fileDataId, docPackageId){
    return axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/feature/docuSign/SignedDocuments/${fileDataId}/${docPackageId}`,
    {
      headers: authHeader() 
    })
    .then(response => {
      return response;
    });
  }
  
  getAuditTrail(fileDataId, docPackageId){
    return axios.get(`${process.env.VUE_APP_API_BASE_URL}/api/feature/docuSign/AuditTrail/${fileDataId}/${docPackageId}`,
    {
      headers: authHeader() 
    })
    .then(response => {
      return response;
    });
  }
}

export default new DocuSignService();